import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";

export interface EmbedConfig {
  embedUrl: string;
  embedToken: string;
  reportId: string;
  reportName: string;
  expiration: string;
}

export default function ReportViewer({ config }: { config: EmbedConfig }) {
  return (
    <section
      style={{ flex: 1, width: "100%", minHeight: 0, display: "flex" }}
      data-testid="report-viewer"
    >
      <div style={{ width: "100%", height: "100%" }}>
        <PowerBIEmbed
          embedConfig={{
            type: "report",
            id: config.reportId,
            embedUrl: config.embedUrl,
            accessToken: config.embedToken,
            tokenType: models.TokenType.Embed,
            settings: {
              layoutType: models.LayoutType.Custom,
              customLayout: {
                displayOption: models.DisplayOption.FitToPage
              },
              panes: {
                filters: { expanded: false, visible: true }
              }
            }
          }}
          cssClassName="pbi-embed"
          eventHandlers={
            new Map([
              ["loaded", () => console.log("Report loaded")],
              ["rendered", () => console.log("Report rendered")],
              ["error", (e: unknown) => console.error("Embed error", e)]
            ])
          }
        />
      </div>
    </section>
  );
}
